module.exports = __webpack_public_path__ + "img/upload-your-photo.03dbeef1.png";